import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../shared/api/firebase/config';

export function useAuth() {
  const [currentUser, setCurrentUser] = useState(() => auth?.currentUser || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setCurrentUser(u || null);
      setLoading(false);
    });
    return () => {
      try {
        unsub();
      } catch (e) {
      }
    };
  }, []);

  return { currentUser, loading };
}
